import { FC, useEffect, useState } from "react";
import { useAuth } from "../../../utility/useAuth";
import { INonProductionJob } from "../../../types/INonProductionJob";
import { getNonProductionJobs } from "../../../services/ApiService";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { Col, Container, Row } from "react-grid-system";
import { LabelText } from "./StartNonProductionJobModal.styles";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import { DateTimePickerComponent } from "@syncfusion/ej2-react-calendars";

interface IStartNonProductionJobModal {
  open: boolean;
  onStartJob: (
    jobNumber: string,
    operation: string,
    from?: Date,
    to?: Date
  ) => void;
  onClose: () => void;
  user: string;
}

export const StartNonProductionJobModal: FC<IStartNonProductionJobModal> = ({
  open,
  onStartJob,
  onClose,
  user,
}) => {
  const dialogHeader = "CSM Shopfloor";

  const auth = useAuth();

  useEffect(() => {
    getNonProductionJobs(auth).then((result) => {
      const operations = result.map((job) => {
        return job.operation;
      });
      console.log(JSON.stringify(operations));
      setData(operations);
      setJobs(result);
      setJob(result[0].jobNumber);
      setOperation(result[0].operation);
    });
  }, [auth]);

  const [job, setJob] = useState("");
  const [operation, setOperation] = useState("");
  const [jobs, setJobs] = useState<INonProductionJob[]>([]);
  const [data, setData] = useState<string[]>([]);
  const [logPastJob, setLogPastJob] = useState(false);
  const [from, setFrom] = useState<Date>(new Date());
  const [to, setTo] = useState<Date>(new Date());

  const buttons = [
    {
      buttonModel: {
        content: "Yes",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        onStartJob(
          job,
          operation,
          logPastJob ? from : undefined,
          logPastJob ? to : undefined
        );
      },
    },
    {
      buttonModel: {
        content: "No",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 200 };

  function onJobChange(args: any) {
    if (args) {
      setJob(jobs.find((j) => j.operation === args.value)?.jobNumber ?? "");
      setOperation(args.value);
    }
  }

  function onChangeLogPastJob(args: any) {
    if (args) {
      setLogPastJob(args.target.checked);
    }
  }

  const fields = { text: "operation", value: "jobNumber" };

  return (
    <DialogComponent
      width="400px"
      close={onClose}
      header={dialogHeader}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <div className="dialogContent">
        <Container fluid>
          <Row align="stretch">
            <>{user}, are you sure that you want to start job?</>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>Job</LabelText>
            </Col>
            <Col>
              <DropDownListComponent
                id="ddlelement"
                dataSource={data}
                value={operation}
                placeholder="Select an job"
                onChange={onJobChange}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <CheckBoxComponent
              label="Log past job"
              onChange={onChangeLogPastJob}
            />
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>From</LabelText>
            </Col>
            <Col>
              <DateTimePickerComponent
                id="datetimepickerFrom"
                value={from}
                enabled={logPastJob}
                placeholder="Select a date and time"
                format="dd/MM/yyyy HH:MM:ss"
                onChange={(args: any) => {
                  setFrom(args.value as Date);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>To</LabelText>
            </Col>
            <Col>
              <DateTimePickerComponent
                id="datetimepickerTo"
                value={to}
                enabled={logPastJob}
                placeholder="Select a date and time"
                format="dd/MM/yyyy HH:MM:ss"
                onChange={(args: any) => {
                  setTo(args.value as Date);
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </DialogComponent>
  );
};
